import { render, staticRenderFns } from "./BplSeasonalRating.vue?vue&type=template&id=91f88d7c&scoped=true"
import script from "./BplSeasonalRating.vue?vue&type=script&lang=js"
export * from "./BplSeasonalRating.vue?vue&type=script&lang=js"
import style0 from "./BplSeasonalRating.vue?vue&type=style&index=0&id=91f88d7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f88d7c",
  null
  
)

export default component.exports